import { mapGetters } from 'vuex'

export const PrefixMixins = {
  watch: {
    $route() {
      this.refreshPrefix()
    },
  },
  data() {
    return {
      Prefix: {
        Affiliate: {
          useAffiliate: 'Loading...',
          minWithdraw: 'Loading...',
          turnover: 'Loading...',
          percent: {
            level1: {
              enable: 'Loading...',
              percent: 'Loading...',
            },
            level2: {
              enable: 'Loading...',
              percent: 'Loading...',
            },
          },
          autoWithdraw: {
            useautoWithdraw: 'Loading...',
            maxautoWithdraw: 'Loading...',
          },
        },
        Withdraw: {
          autoWithdraw: {
            maxautoWithdraw: 'Loading...',
            useautoWithdraw: 'Loading...',
          },
          canWithdraw: 'Loading...',
          maxWithdraw: 'Loading...',
          minWithdraw: 'Loading...',
        },
        Disabled: 'Loading...',
        LineId: 'Loading...',
        Maintenance: 'Loading...',
        Partner: 'Loading...',
        Product: [],
        Promotion: [],
        cashBack: {
          Payout: 'Loading...',
          minWithdraw: 'Loading...',
          usecashBack: 'Loading...',
        },
        getNameBank: 'Loading...',
        logoUrl: 'Loading...',
        theme: 'Loading...',
      },
    }
  },
  computed: {
    ...mapGetters(['getError', 'getLoading', 'getPrefix']),
  },
  methods: {
    async refreshPrefix() {
      if (this.getPrefix != '') {
        this.Prefix = await this.getPrefix
      }
    },
  },
  async mounted() {
    if (this.getPrefix != '') {
      this.Prefix = await this.getPrefix
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/Prefix.js